import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#fff200',
                secondary: '#0070af',
                info: '#4583f4',
                success: '#8BC34A',
                error: '#c53929'
            },
            dark: {
                primary: '#fff200',
                secondary: '#0070af',
                info: '#4583f4',
                success: '#8BC34A',
                error: '#c53929'
            }
        }
    }
});